import apiClient from './index'
import type { SalesPlan } from '@/types'
import type { PlanningGridResponse } from '@/types/planning'

const BASE_URL = '/ssp/sales-plans'

export interface SalesPlanCreate {
  scenario_id: number
  product_id: number
  period: string
  base_velocity: number
  coefficients?: Record<string, unknown> | null
  planned_quantity: number
  planned_price: number
  supply_quantity: number
  is_manual_override?: boolean
}

export interface SalesPlanUpdate {
  base_velocity?: number
  coefficients?: Record<string, unknown> | null
  planned_quantity?: number
  planned_price?: number
  supply_quantity?: number
  is_manual_override?: boolean
  version: number
}

export interface SalesPlanFilters {
  scenario_id: number
  product_id?: number
  period?: string
  period_from?: string
  period_to?: string
}

export interface GridFilters {
  scenario_id: number
  period_from: string
  period_to: string
  cabinet_id?: number
  brand?: string
  category_id?: number
  force_refresh?: boolean
}

export interface PlanCalculateRequest {
  product_id: number
  scenario_id: number
  base_velocity: number
  prices: Record<number, number>
  advertising_rate?: number | null
  start_period: string
}

export interface SalesPlanBulkUpdateItem {
  plan_id: number
  data: SalesPlanUpdate
}

export interface SalesPlanBulkUpdatePayload {
  scenario_id: number
  items: SalesPlanBulkUpdateItem[]
}

export const salesPlansApi = {
  getAll: (params: SalesPlanFilters) =>
    apiClient.get<SalesPlan[]>(BASE_URL, { params }).then((res) => res.data),
  getById: (id: number) =>
    apiClient.get<SalesPlan>(`${BASE_URL}/${id}`).then((res) => res.data),
  create: (data: SalesPlanCreate) =>
    apiClient.post<SalesPlan>(BASE_URL, data).then((res) => res.data),
  update: (id: number, data: SalesPlanUpdate) =>
    apiClient.put<SalesPlan>(`${BASE_URL}/${id}`, data).then((res) => res.data),
  delete: (id: number) =>
    apiClient.delete<SalesPlan>(`${BASE_URL}/${id}`).then((res) => res.data),
  getGrid: (params: GridFilters) =>
    apiClient
      .get<PlanningGridResponse>(`${BASE_URL}/grid`, { params })
      .then((res) => res.data),
  calculate: (data: PlanCalculateRequest) =>
    apiClient
      .post(`${BASE_URL}/calculate`, data)
      .then((res) => res.data),
  bulkCreate: (payload: { scenario_id: number; plans: SalesPlanCreate[] }) =>
    apiClient
      .post(`${BASE_URL}/bulk-create`, payload)
      .then((res) => res.data),
  bulkUpdate: (payload: SalesPlanBulkUpdatePayload) =>
    apiClient
      .post<SalesPlan[]>(`${BASE_URL}/bulk-update`, payload)
      .then((res) => res.data),
}
